export default __webpack_public_path__ + "c3d915205acc3075d572082f9e647807.png";